<div class="summary-row" [style.margin-left.px]="summaryMarginLeft">
    <div class="summary-cell summary-cell--left">
        <div class="label">Okres rozliczeniowy</div>
        <div class="report-item-value">{{billingReport?.billingPeriod?.from | date: 'dd.MM.yyyy'}} - {{billingReport?.billingPeriod?.to | date: 'dd.MM.yyyy'}}</div>
    </div>
    <div class="summary-cell">
        <div class="label">
            Zamówień
            <svg class="metric-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7V4z"/></svg>
        </div>
        <div class="report-item-value">{{ billingReport?.ordersCount }}</div>
    </div>
    <div class="summary-cell">
        <div class="label">
            Produktów
            <svg class="metric-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/></svg>
        </div>
        <div class="report-item-value">{{ billingReport?.productsCount }}</div>
    </div>
    <div class="summary-cell">
        <div class="label">
            Ofert
            <svg class="metric-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/></svg>
        </div>
        <div class="report-item-value">{{ billingReport?.auctionsCount }}</div>
    </div>
    <div class="summary-cell">
        <div class="label">
            Przesyłek
            <svg class="metric-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7V4z"/></svg>
        </div>
        <div class="report-item-value">{{ billingReport?.shipmentsCount }}</div>
    </div>
</div>
<div id="daily-reports-table-wrapper" [style.max-height.px]="tableHeight">
    <mat-table id="daily-reports-table" [dataSource]="billingReport?.dailyReports ?? []">
        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef>Data</mat-header-cell>
            <mat-cell *matCellDef="let item">{{item.date | date: 'dd.MM.yyyy'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="ordersCount">
            <mat-header-cell *matHeaderCellDef class="cell-center">Zamówień</mat-header-cell>
            <mat-cell *matCellDef="let item" class="cell-center">{{item.ordersCount}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="productsCount">
            <mat-header-cell *matHeaderCellDef class="cell-center">Produktów</mat-header-cell>
            <mat-cell *matCellDef="let item" class="cell-center">{{item.productsCount}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="auctionsCount">
            <mat-header-cell *matHeaderCellDef class="cell-center">Ofert</mat-header-cell>
            <mat-cell *matCellDef="let item" class="cell-center">{{item.auctionsCount}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="shipmentsCount">
            <mat-header-cell *matHeaderCellDef class="cell-center">Przesyłek</mat-header-cell>
            <mat-cell *matCellDef="let item" class="cell-center">{{item.shipmentsCount}}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="['date', 'ordersCount', 'productsCount', 'auctionsCount', 'shipmentsCount']"></mat-header-row>
        <mat-row *matRowDef="let item; columns: ['date', 'ordersCount', 'productsCount', 'auctionsCount', 'shipmentsCount']"></mat-row>
    </mat-table>
</div>
